/**
 * Toucan by Babbel - Language Learning
 *
 * Exposes several WAR groups — `animations/*`, `fonts/*.woff2`, `images/*`, `_locales/*`
 * and the standalone `history-change-listener.js` — matched to http(s) origins with no
 * `use_dynamic_url`, so these assets are fetchable at fixed URLs from any page.
 *
 * The bundled icon is the cleanest signal: images/icons/development/icon128.png loads
 * through probeImage with no CORS grant. history-change-listener.js is a distinctively
 * named standalone content script, and highlights.json is a vendor animation asset.
 *
 * Manifest verified against version 2.19.8.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lokjgaehpcnlmkebpmjiofccpklbmoci';

export const toucan: ExtensionDefinition = {
  id: ID,
  name: 'Toucan by Babbel - Language Learning',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'animations/*, images/*, fonts and a named content script exposed to http(s) origins ' +
    'with no dynamic URL. The bundled icon is conclusive and CORS-free.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load images/icons/development/icon128.png via <img> — a bundled icon exposed to ' +
        'http(s) origins, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/icons/development/icon128.png'),
    },
    {
      id: 'war-history-change-listener-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch history-change-listener.js — a distinctively named standalone content ' +
        'script exposed as its own WAR entry.',
      weight: 0.5,
      run: () => probeFetch(ID, 'history-change-listener.js'),
    },
    {
      id: 'war-highlights-animation',
      kind: 'web-accessible-resource',
      description:
        'Fetch animations/highlights.json — a Lottie animation asset, an independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'animations/highlights.json'),
    },
  ],
};
